import type { ParsedUrlQuery } from 'node:querystring'

export function normalizeUrl(url = '') {
  let newStr = ''
  for (let i = 0; i < url.length; i++) {
    const char = url.charCodeAt(i)
    if (
      (char >= 65 && char <= 90) ||
      (char >= 97 && char <= 122) ||
      (char >= 48 && char <= 57)
    ) {
      newStr += url.charAt(i)
    } else {
      if (newStr.charAt(newStr.length - 1) !== '-' && i !== url.length - 1) {
        newStr += '-'
      }
    }
  }
  if (newStr.charAt(0) === '-') {
    newStr = newStr.substring(1, newStr.length)
  }
  if (newStr.charAt(newStr.length - 1) === '-') {
    newStr = newStr.substring(0, newStr.length - 1)
  }
  return newStr.toLowerCase()
}

export function normalizePagePath(path: string, pagePrefix: string) {
  if (
    path.startsWith(pagePrefix) &&
    ['/', undefined, '?', '#'].includes(path[pagePrefix.length])
  ) {
    const result = path.replace(`${pagePrefix}`, '')
    return result.startsWith('/') ? result : `/${result}`
  }
  return path
}

/**
 * Next.js 暂不支持，自行封装工具函数解析
 *
 * ref: https://github.com/vercel/next.js/issues/63005
 */
export function normalizeServerSideReqUrl(
  origin: string,
  url?: string,
  query?: ParsedUrlQuery,
) {
  if (!url) {
    throw new Error('`url` is empty')
  }

  const result = new URL(url, origin)

  if (
    result.pathname.startsWith('/_next/data/') &&
    result.pathname.endsWith('.json')
  ) {
    result.pathname = `/${result.pathname
      .replace(/\/index\.json$/, '/')
      .replace(/\.json$/, '')
      .split('/')
      .slice(4)
      .join('/')}`
  }

  // 单页路由时客户端会额外携带 rewrites 的 host 参数，如果 ctx.query 中 host 与查询参数中的 host 一致时移除该参数，
  // 保证与客户端 asPath 结果一致。
  if (query && query.host === result.searchParams.get('host')) {
    result.searchParams.delete('host')
  }

  return { asPath: `${result.pathname}${result.search}`, url: result }
}
